import React, { useState } from "react";
import { API } from "../backend";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from "../../Component/Footer";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Logo from "../../images/logo.png";
import ProceedModal from "../../Component/ProceedModal"; // will need to be changed to account for school ID i think
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import LatePaymentPublicModel from "../../Component/latepaymentform/latepayment_pub_model";
import LateReqPublic from "../../Component/latepaymentform/latepayment_public";


const PublicSecLatePaymentForm = () => {
  const [school, setSchool] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [schoolType, setSchoolType] = useState("");
  const [localGovt, setLocalGovt] = useState("");
  const [closing, setClosing] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [mda, setMda] = useState("");
  const [pinNum, setPinNum] = useState();
  const [totalPrice, setTotalPrice] = useState("");
  const [genInfo, setGenInfo] = useState([]);
  const [lgaId, setLgaId] = useState("");
  const [schoolTypeId, setSchoolTypeId] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const handleSchool = (e) => {
    setSchool(e.target.value);
  };
  const handleSchoolType = async (e) => {
    setSchoolType(e.target.value);
    const schType = e.target.value;
    console.log(schType);
    const response = await axios.get(`${API}typebece/${schType}/`);
    console.log(response);
    setGenInfo(response.data);
  };

  const handleLocalGovt = (e) => {
    setLocalGovt(e.target.value);
  };

  const handleName = (e) => {
    setName(e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };
  const handlePhone = (e) => {
    const red = /^[0-9\b]+$/;
    if (e.target.value === "" || red.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
  };

  const handleTotalPrice = (e) => {
    setTotalPrice(e.target.value);
  };

  // const handlepin = (e) => {
  const handleSchoolId = (e) => {
    setSchoolId(e.target.value);
    const schoolInfo = genInfo.filter(
      (info) => info.SchoolId === e.target.value
    );
    console.log(schoolInfo);
    // update the states
    if (schoolInfo) {
      setSchool(schoolInfo ? schoolInfo[0].SchoolName : "");
      setLocalGovt(schoolInfo ? schoolInfo[0].LgaName : "");
      setName(schoolInfo ? schoolInfo[0].PayerName : "");
      setEmail(schoolInfo ? schoolInfo[0].Payeremail : "");
      setPhone(schoolInfo ? schoolInfo[0].Payerphone : "");
      setAddress(schoolInfo ? schoolInfo[0].Street : "");
      setClosing(schoolInfo ? schoolInfo[0].ClosingDate : "");
      setLgaId(schoolInfo ? schoolInfo[0].LgaId : "");
      setSchoolTypeId(schoolInfo ? schoolInfo[0].SchoolTypeId : "");
    } else {
      alert("fetching not successful");
      setSchool("");
      setLocalGovt("");
      setName("");
      setEmail("");
      setPhone("");
      setAddress("");
    }
  };

  const updateData = async () => {
    const obj = {
      TotalPrice: 5000,
      Mda: "PAID",
      // LgaId : lgaId,
      ClosingDate: closing,
      // SchoolTypeId : schoolTypeId
    };
    console.log(obj);

    try {
      const resp = await axios.put(
        `${API}beceannualcharges/${schoolId}/${schoolType}/`,
        obj
      );

      //  console.log(resp)
      if (resp.status === 200) {
        setOpen(true);
        setPinNum("PAID");
        setMda("");
        setTotalPrice("");
        setName("");
        setEmail("");
        setPhone("");
        navigate("/requisition/bece");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const config = {
    public_key: process.env.REACT_APP_PUBLIC_KEY,
    tx_ref: Date.now(),
    amount: 5000,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: email,
      phonenumber: phone,
    },
    customizations: {
      title: "Lagos Pay",
      description: "PAYMENT FOR EXAMINATION (CBS)",
      logo: "https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  const handlePayment = async () => {
    handleFlutterPayment({
      callback: (response) => {
        if (response.status === "successful") {
          updateData();
        }
      },
      onClose: () => { },
    });
  };

  const handleClick = async (e) => {
    e.preventDefault();

    handlePayment();
  };

  const types = [
    {
      name: "0",
      label: "PRIVATE",
    },
    {
      name: "1",
      label: "PUBLIC",
    },
  ];

  return (
    <div >

      <LateReqPublic  examType={'PUBLIC SERVICE EXAMINATION'} examName={'Public Service'} lateRegistrationType="Public Service Late Registration" />


      {/* <Footer /> */}
    </div>
  );
};

export default PublicSecLatePaymentForm;
